import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import routes from 'js/core_pre_webpack/routes';
import { openFacebookShareDialog } from 'js/facebook/share_dialog';

// gerneralized for use on both swp and canonical react work cards
class ShareWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: _.map(props.initialSuggestions, function (suggestion) {
        return suggestion.user;
      }),
      inputValue: '',
      fetching: false,
      shared: props.alreadyShared,
      hideModal: props.hideModal,
    };
    this.debouncedGetSearchResults = _.debounce(this.getSearchResults, 300);
  }

  componentDidMount() {
    if (Aedu.User.current) {
      Kale.notify({
        collectionName: this.props.collectionName,
        eventData: {
          event: 'shares_sidebar_shown',
          user_id: Aedu.User.current.id,
          count: this.state.users.length,
        },
      });
      this.getAlreadyShared();
    }
  }

  render() {
    let bottomSection;
    if (this.state.fetching) {
      bottomSection = this.renderSpinner();
    } else if (this.state.users.length > 0) {
      bottomSection = this.renderSuggestions();
    } else {
      bottomSection = this.renderZeroState();
    }

    return this.shareModal(bottomSection);
  }

  shareModal(bottomSection) {
    const buttonStyle = {
      borderRadius: '20px',
      maxWidth: '36px',
      maxHeight: '36px',
      padding: '18px',
    };

    // if on swp the window knows the url, else use url prop
    let url;
    if (this.props.workUrl == null) {
      url =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname;
    } else {
      url = this.props.workUrl;
    }
    const urlWithSource = url + '?source=' + this.props.source;

    return (
      <div className="DesignSystem">
        <div className="js-share-modal">
          <div className="u-displayFlex u-justifyContentSpaceBetween u-mb4x">
            <div className="u-fw500 u-fs24 u-ph6x u-pv2x">Share this Paper</div>
            <div className="u-ph6x u-displayFlex">
              <button
                className="Button Button--grayLight u-bgColorGrayLight u-borderColorWhite u-mh1x"
                style={buttonStyle}
                onClick={(e) => this.handleCopy(e, urlWithSource)}
              >
                <i
                  className="fa fa-link u-positionAbsolute u-tcGrayDarkest u-fw700 u-fs18"
                  style={{ top: '9px', left: '11px' }}
                />
              </button>
              <button
                className="Button Button--twitter u-borderColorWhite u-mh1x"
                style={buttonStyle}
                onClick={(e) => this.handleTweet(e, url)}
              >
                <i
                  className="fa fa-twitter u-positionAbsolute u-fw700 u-fs18"
                  style={{ top: '9px', left: '11px' }}
                />
              </button>
              <button
                className="Button Button--facebook u-borderColorWhite u-mh1x"
                style={buttonStyle}
                onClick={(e) => this.handleFacebook(e, url)}
              >
                <i
                  className="fa fa-facebook-f u-positionAbsolute u-fw700 u-fs18"
                  style={{ top: '9px', left: '13px' }}
                />
              </button>
            </div>
          </div>

          {Aedu.User.current ? (
            <>
              <div
                className="js-pick-me u-pb4x u-positionRelative u-ph6x"
                style={{ zIndex: 1 }}
              >
                <i
                  className="fa fa-search u-positionAbsolute u-tcGrayDark u-fw700"
                  style={{ top: '10px', left: '36px' }}
                />
                <input
                  className="TextInput TextInput--sm u-pl8x u-bgColorGrayLighter u-fs14 u-borderColorGrayLighter"
                  style={{ width: '100%' }}
                  placeholder="Search the Academia.edu network"
                  onChange={(e) => this.handleInput(e)}
                />
              </div>
              <div
                className="u-ph6x u-pb4x"
                style={{
                  maxHeight: '325px',
                  overflowY: 'scroll',
                  overflowX: 'hide',
                }}
                ref={this.scrolly}
              >
                {bottomSection}
              </div>
            </>
          ) : null}
        </div>
      </div>
    );
  }

  renderSuggestions() {
    return _.map(
      this.state.users,
      function (user) {
        const affiliation =
          user.university ||
          (user.department &&
            user.department.university &&
            user.department.university.name);
        const buttonDisabled = _.contains(this.state.shared, user.id);
        const buttonClasses = classNames('Button Button--sm', {
          'Button--inverseGray': buttonDisabled,
          'Button--inverseBlue': !buttonDisabled,
        });
        const buttonStyle = buttonDisabled
          ? {
              paddingLeft: '14px',
              paddingRight: '14px',
              cursor: 'not-allowed',
              pointerEvents: 'none',
            }
          : {};
        const buttonText = buttonDisabled ? 'Shared' : 'Share';
        const widthStyle = { maxWidth: '200px' };
        return (
          <div
            key={user.id}
            className="media_v2 u-mb4x u-displayFlex u-justifyContentSpaceBetween"
          >
            <div>
              <div className="media-left u-floatLeft media-middle u-mr2x">
                <img
                  className="Avatar Avatar--sm"
                  src={user.photo || user.profile_pic_url}
                />
              </div>
              <div
                className="media-body u-floatLeft  media-middle"
                style={widthStyle}
              >
                <div
                  className="u-fs14 u-fw500 u-lineHeight1_2 u-textTruncate u-tcGrayDarkest u-pb1x"
                  style={{ marginBottom: '2px' }}
                >
                  {user.display_name || user.name}
                </div>
                <div className="u-fs13 u-lineHeight1 u-textTruncate u-tcGrayDarkest u-fw400">
                  {affiliation}
                </div>
              </div>
            </div>
            <div className="media-right media-middle u-floatRight u-mv0x">
              <div
                className={buttonClasses}
                id={user.id}
                style={buttonStyle}
                onClick={(e) => this.handleShare(e)}
              >
                {buttonText}
              </div>
            </div>
          </div>
        );
      }.bind(this),
    );
  }

  renderSpinner() {
    return (
      <div className="u-taCenter u-pt4x u-pb8x">
        <i className="fa fa-spin fa-spinner u-fs36 u-tcGrayDark"></i>
      </div>
    );
  }

  renderZeroState() {
    return (
      <div className="u-taCenter u-pt4x u-pb8x u-fontStyleItalic u-tcGrayDark u-fw300">
        No results found
      </div>
    );
  }

  scrolly(el) {
    $(el).on('scroll', function () {
      if ($(el).scrollTop() > 0) {
        $('.js-pick-me').css('box-shadow', '0 3px 5px -2px rgb(221, 221, 221)');
      } else {
        $('.js-pick-me').css('box-shadow', 'none');
      }
    });
  }

  handleInput(event) {
    // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
    // eslint-disable-next-line react/no-direct-mutation-state
    this.state.inputValue = event.currentTarget.value.trim();
    if (this.state.inputValue.length > 1) {
      this.debouncedGetSearchResults();
    } else if (this.state.inputValue.length === 0) {
      this.setState({
        users: _.map(this.props.initialSuggestions, function (suggestion) {
          return suggestion.user;
        }),
      });
    }
  }

  getSearchResults() {
    if (this.state.inputValue.length === 0 || this.state.fetching) return;
    this.setState({ fetching: true });
    $.ajax({
      url: '/users/search',
      data: {
        q: this.state.inputValue,
        hide_users: Aedu.User.current.id,
        include_contacts: true,
      },
    }).done((data) => this.handleResults(data));
    Kale.notify({
      collectionName: this.props.collectionName,
      eventData: {
        event: 'user_search',
        user_id: Aedu.User.current.id,
        query: this.state.inputValue,
      },
    });
  }

  handleResults(data) {
    this.setState({
      users: data.results,
      fetching: false,
    });
  }

  getAlreadyShared() {
    $.ajax({
      type: 'GET',
      dataType: 'json',
      url: routes.api_v0_work_share_path({
        subdomain_param: 'api',
        id: this.props.workId,
      }),
    }).done(
      function (data) {
        this.setState({ shared: data.already_shared });
      }.bind(this),
    );
  }

  handleShare(e) {
    const user_id = e.currentTarget.id;
    $.ajax({
      type: 'POST',
      url: routes.api_v0_work_shares_path({
        subdomain_param: 'api',
      }),
      data: {
        work_share: {
          recipient_id: user_id,
          work_id: this.props.workId,
        },
      },
    })
      .success(
        function (data) {
          if (data.success) {
            const arr = _.clone(this.state.shared);
            arr.push(Number(user_id));
            this.setState({ shared: arr });
            const user = _.where(this.state.users, { id: Number(user_id) })[0];
            let text = 'This paper has been shared';
            if (user) {
              text += ' with ' + (user.display_name || user.name);
            }
            Components.Utils.showToast(Components.Toasts.BasicToast, {
              text: text,
            });
          } else {
            if (
              data.errors &&
              // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
              // eslint-disable-next-line eqeqeq
              data.errors[0] == 'Recipient has already been taken'
            ) {
              Components.Utils.showToast(
                Components.Toasts.BasicToast,
                { text: 'Already shared!' },
                { color: 'Gray' },
              );
            } else {
              Components.Utils.showToast(
                Components.Toasts.BasicToast,
                { text: 'Something went wrong!' },
                { color: 'Red' },
              );
            }
          }
        }.bind(this),
      )
      .fail(
        function () {
          Components.Utils.showToast(
            Components.Toasts.BasicToast,
            { text: 'Something went wrong!' },
            { color: 'Red' },
          );
        }.bind(this),
      );
  }

  handleCopy(_event, url) {
    const urlTextArea = document.createElement('textarea');
    urlTextArea.textContent = url;
    urlTextArea.value = url;
    urlTextArea.innerHTML = url;
    document.body.appendChild(urlTextArea);

    const selection = document.getSelection();
    const range = document.createRange();
    range.selectNode(urlTextArea);
    selection.removeAllRanges();
    selection.addRange(range);

    if (document.execCommand('copy')) {
      Components.Utils.showToast(Components.Toasts.BasicToast, {
        text: 'URL copied to clipboard!',
      });
    } else {
      Components.Utils.showToast(
        Components.Toasts.BasicToast,
        { text: 'Something went wrong!' },
        { color: 'Red' },
      );
    }

    selection.removeAllRanges();
    document.body.removeChild(urlTextArea);
  }

  handleTweet(_event, url) {
    window.thisTweetText = this.props.workTitle
      ? this.props.workTitle
      : 'Check this paper out!';
    window.thisTweetVia = 'academia';
    window.Academia.openTwitterShareWindow(
      window.thisTweetText,
      url,
      window.thisTweetVia,
    );
    this.state.hideModal();
  }

  handleFacebook(_event, url) {
    openFacebookShareDialog(url);
    this.state.hideModal();
  }
}

ShareWork.propTypes = {
  initialSuggestions: PropTypes.arrayOf(PropTypes.object).isRequired,
  alreadyShared: PropTypes.arrayOf(PropTypes.number).isRequired,
  workId: PropTypes.number.isRequired,
  workTitle: PropTypes.string,

  // the following were added to generalize this modal for use on different pages, in additon to swp
  collectionName: PropTypes.string.isRequired, // for kale logging
  source: PropTypes.string.isRequired, // share url source param

  hideModal: PropTypes.func.isRequired, // function to close modal

  // if given, will be used copied to user's clipboard on copy button press
  // if not given, will assume on the swp and will use the window's location
  workUrl: PropTypes.string,
};

export default ShareWork;

// wrapper around ShareWork so it looks better on a bootstrap modal
export const ShareWorkModal = (props) => (
  <div className="work-card-modal--share-work-wrapper">
    <div className="work-card-modal--share-work-header">
      <button
        className="close work-card-modal--share-work-close-button"
        onClick={() => $('.modal').modal('hide')}
      >
        <span>×</span>
      </button>
    </div>
    <ShareWork {...props} />
  </div>
);
ShareWorkModal.propTypes = ShareWork.propTypes;
